<template lang="pug">
    Row
        Col(:xl="12" :lg="24")
            BulletinBoardCard.dashBoardCard(v-if="$store.state.frontendConfigs.isShowBulletinBoard")
            GroupCard.dashBoardCard(v-if="$store.getters.hasMultiGroups||$store.getters.isAdmin")
            AssetCard.dashBoardCard(v-else)
            ResourceFinder.dashBoardCard
        Col(:xl="12" :lg="24")
            AssetCard.dashBoardCard(v-if="$store.getters.hasMultiGroups||$store.getters.isAdmin")
            DashBoardHelperCard.dashBoardCard
        //- CreditCardModal(v-if="$store.getters.isAdmin != true")
</template>
<script>
import AssetCard from "@/components/Home/AssetCard";
import DashBoardHelperCard from "@/components/Home/DashBoardHelperCard";
import SupportCard from "@/components/Home/SupportCard";
import GroupCard from "@/components/Home/GroupCard";
import ResourceFinder from "@/components/Home/ResourceFinderV2";
import BulletinBoardCard from "@/components/Home/BulletinBoardCard";

// import CreditCardModal from "@/components/Home/CreditCardModal";

export default {
    name: "Home",
    components: {
        AssetCard,
        DashBoardHelperCard,
        SupportCard,
        GroupCard,
        ResourceFinder,
        BulletinBoardCard,
        // CreditCardModal
    },
    data() {
        return {};
    },
    methods: {},
    mounted() {},
};
</script>

<style scoped>
.dashBoardCard {
    /* text-align: center; */
    margin: 6px 6px 0px 6px;
}
</style>



// WEBPACK FOOTER //
// src/view/Home.vue